(() => {
  const form = document.querySelector('[data-ab-form]');
  if (!form) return;

  const gate = document.querySelector('#fit-check');
  const qualified = document.querySelector('[data-ab-qualified]');
  const nurture = document.querySelector('[data-ab-nurture]');
  const error = document.querySelector('[data-ab-error]');
  const calendly = document.querySelector('[data-ab-calendly]');

  document.querySelectorAll('a[href*="calendly.com"]').forEach((link) => {
    if (link === calendly) return;
    link.addEventListener('click', (event) => {
      event.preventDefault();
      gate.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (!form.reportValidity()) {
      error.hidden = false;
      return;
    }

    error.hidden = true;
    const answers = new FormData(form);
    const isQualified = answers.get('trading') !== 'no' &&
      answers.get('authority') !== 'no' &&
      answers.get('paid') === 'yes';

    form.hidden = true;
    qualified.hidden = !isQualified;
    nurture.hidden = isQualified;

    if (isQualified) {
      const current = new URL(window.location.href);
      const booking = new URL(calendly.href);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((key) => {
        const value = current.searchParams.get(key);
        if (value) booking.searchParams.set(key, value);
      });
      calendly.href = booking.toString();
      qualified.focus();
    } else {
      nurture.focus();
    }
  });
})();
